import approvalForm from './metaData/approvalForm'

import { SettingEnableStatus } from '@/api/setting'

// import lang from '@/lang'
export default {
  EnableChannelUser({ commit }, params) {
    var req_params = {
      idList: [],
      enabled: true
    }

    for (const iterator of params.rows) {
      req_params.idList.push(iterator.approvalObjId)
    }

    return SettingEnableStatus(req_params)
  },
  DisableChannelUser({ commit }, params) {
    var req_params = {
      idList: [],
      enabled: false
    }

    for (const iterator of params.rows) {
      req_params.idList.push(iterator.approvalObjId)
    }

    return SettingEnableStatus(req_params)
  },
  ApprovalChannelUser({ commit }, params) {
    const props = {
      params: { id: params.rowId }
    }
    this.dispatch('OpenFullDialog', { metaData: approvalForm, props, clone: false })
  }
}
